(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
// Set CSS custom property for desktop columns dynamically
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-collection-grid');
  sections.forEach(section => {
    const desktopColumns = section.querySelector('.custom-collection-grid__wrapper').children.length;
    section.style.setProperty('--desktop-columns', desktopColumns);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
// Set CSS custom property for desktop columns dynamically
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-collection-grid');
  sections.forEach(section => {
    const desktopColumns = section.querySelector('.custom-collection-grid__wrapper').children.length;
    section.style.setProperty('--desktop-columns', desktopColumns);
  });
});

  } catch(e) { console.error(e); }
})();
})();
